import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { X_EXCLUDE_BASE_URL } from '../constants/http-headers';
import { EnvironmentService } from '../services/environment.service';

/**
 * Prepends a base URL to every HTTP request.
 */
@Injectable({
  providedIn: 'root'
})
export class ApiBaseUrlInterceptor implements HttpInterceptor {
  constructor(private environmentService: EnvironmentService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const bypassInterceptor = req.headers.get(X_EXCLUDE_BASE_URL) === '1';

    // Allow requests to opt out of prepending the app server's base URL
    if (bypassInterceptor) {
      return next.handle(req);
    } else {
      return next.handle(
        req.clone({
          url: (req.url.startsWith('http') ? '' : this.environmentService.apiBaseUrl) + req.url
        })
      );
    }
  }
}
